import React, { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Divider, Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { Container } from "react-bootstrap";
import Title from "antd/es/typography/Title";
import Navbar from "../../components/Navbar/Navbar";
import logo from "../../assets/images/navbar_logo.png";
import { capitalizeEachWord, formatDate } from "../../utils/Common";
import ReactToPrint from "react-to-print";

export default function ViewAnnouncement() {
  const location = useLocation();
  const navigate = useNavigate();
  const componentRef = useRef();
  const passedData = location.state;

  return (
    <Navbar activeNav="announcement" isForm>
      <Container className="p-4 view-page">
        <div ref={componentRef}>
          <Row>
            <Col xs={24} lg={1} className="me-4">
              <img src={logo} alt="logo" className="view-page-logo" />
            </Col>
            <Col>
              <Row>
                <Title level={3}>{window.$company_name}</Title>
              </Row>
              <Row>{window.$company_address}</Row>
            </Col>
          </Row>
          <Divider />
          <Row className="center my-3">
            <Title level={4}>ANNOUNCEMENT NO. {passedData.code}</Title>
          </Row>
          <Row>
            <Col md={3} lg={2}>Date</Col>
            <Col xs={1}>:</Col>
            <Col>{formatDate(passedData.announcement_date)}</Col>
          </Row>
          <Row>
            <Col md={3} lg={2}>To</Col>
            <Col xs={1}>:</Col>
            <Col>
              {(function () {
                let to = passedData.details
                  ? passedData.details.map((t) => t.announcement_to)
                  : [];
                return to.join(", ");
              })()}
            </Col>
          </Row>
          <Row>
            <Col md={3} lg={2}>From</Col>
            <Col xs={1}>:</Col>
            <Col>{capitalizeEachWord(passedData.announcement_from)}</Col>
          </Row>
          <Row>
            <Col md={3} lg={2}>Subject</Col>
            <Col xs={1}>:</Col>
            <Col>{capitalizeEachWord(passedData.subject)}</Col>
          </Row>
          <Divider />
          <Row className="px-5 py-2 center">
            <div
              dangerouslySetInnerHTML={{
                __html: passedData.content ? passedData.content : "",
              }}
            />
          </Row>

          <Row className="mt-5">Prepared by:</Row>
          <Col xs={24} md={10} lg={7} className="text-center mt-3">
            <Row className="d-flex justify-content-center">{passedData.added_by_name?.toUpperCase()}</Row>
            <Divider className="black-divider" />
            <Row className="d-flex justify-content-center">{passedData.added_by_role==="admin"?"HR Head":"HR Staff"}</Row>
          </Col>

          <Row className="mt-5">Approved by:</Row>
          <Col xs={24} md={10} lg={7} className="text-center mt-3">
          <Row className="d-flex justify-content-center">{passedData.approved_by_name?.toUpperCase()}</Row>
            <Divider className="black-divider" />
            <Row className="d-flex justify-content-center">{passedData.approved_by_role==="admin"?"HR Head":"HR Staff"}</Row>
          </Col>
        </div>

        <Row className="d-flex justify-content-end noPrint mt-5">
          <Row>
            <Button
              className="cancel-btn me-2"
              onClick={() => navigate("/announcements")}
            >
              Cancel
            </Button>
            <ReactToPrint
              trigger={() => (
                <Button type="primary">
                  <PrinterOutlined /> Print
                </Button>
              )}
              content={() => componentRef.current}
            />
          </Row>
        </Row>
      </Container>
    </Navbar>
  );
}
